/**
 * Default logo URL for organizations when no custom logo is provided
 */
export const DEFAULT_ORGANIZATION_LOGO = "/default-org-logo.webp";

/**
 * Maximum file size for logo uploads (in bytes)
 * 6MB = 6 * 1024 * 1024
 */
export const MAX_LOGO_FILE_SIZE = 6 * 1024 * 1024;

/**
 * Maximum dimensions for logo images
 */
export const MAX_LOGO_DIMENSIONS = {
	width: 2048,
	height: 2048,
};

/**
 * Allowed file types for logo uploads
 */
export const ALLOWED_LOGO_TYPES = ["jpg", "jpeg", "png", "gif", "webp"];
